import { useEffect, useState } from "react"
import HTMLNotebook from '../../../components/Notebook/HTMLNotebook';
import ReactDOMServer from "react-dom/server"
import { Modal } from "react-bootstrap";
import ApiServices from "../../../utils/apiServices";
import * as FileSaver from 'file-saver';
import { imsLoader } from "../../../assets";
import Button from "../../../components/Button";
import HTMLNootBookAI from "./HTMLNootBookAI";
const NoteBookExport = (props) => {
    const [showPop, setShowPop] = useState(false);
    const [saveFormat, setSaveFormat] = useState('');
    const [isExportOriginalText, setIsExportOriginalText] = useState(false);
    const [notebookName, setNotebookName] = useState('');
    const [selectedResults, setselectedResults] = useState([]);
    const [docProcessing, setDocProcessing] = useState(false);


    useEffect(() => {
        setShowPop(props.showPop);
        if(props.isSummary){
        let selected_sum = props.summary.filter( x => props.checkedSum.includes(x.id))
        setselectedResults(selected_sum)
        }else{
            let selected_note = props.notes.filter( x => props.checkedNote.includes(x.id))
            setselectedResults(selected_note)
        }
        setNotebookName(props.selectedNotebookName)
    }, [])

    const handleOnChangeSaveFormat = (event) => {
        setSaveFormat(event.target.value)
    }
    const generateDownloadTimestamp = () => {
        const now = new Date()
        return now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate() + "_" + now.getHours() + "-" + now.getMinutes() + "-" + now.getSeconds()
    }
    const onClickProceed = async () => {
        let _notebookItems = Object.assign([], selectedResults);
        // this.setState({ docProcessing: true })
        const service = new ApiServices();
        if (saveFormat === "Word") {
            let fileName = `${notebookName}_${generateDownloadTimestamp()}.docx`;
            setDocProcessing(true)
            const html = ReactDOMServer.renderToString(<HTMLNootBookAI 
                notebookName={notebookName} selected={[]} 
                notebookItems={selectedResults} isExportOriginalText={isExportOriginalText}
                />);
            await service.prepareDocx(html, 'Word').then((res) => {
                const data = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
                FileSaver.saveAs(data, fileName);
            }).catch((error) => {
                console.log(error);
            }).finally(() => {
                setDocProcessing(false);
                props.handleClose();
                //this.setState({ docProcessing: false, showPop: false, saveFormat: "Word" })
            })
        }
        else if (saveFormat === "Pdf") {
            setDocProcessing(true)
            let fileName = `${notebookName}_${generateDownloadTimestamp()}.pdf`;
            const html = ReactDOMServer.renderToString(<HTMLNootBookAI 
                selected={[]} notebookName={notebookName} 
                notebookItems={selectedResults} isExportOriginalText={isExportOriginalText} />);
            await service.preparePDFDocumentGenAI(html).then((res) => {
                const data = new Blob([res.data], { type: 'application/pdf' });
                FileSaver.saveAs(data, fileName);
            }).catch((error) => {
                console.log(error);
            }).finally(() => {
                setDocProcessing(false)
                props.handleClose()
                // this.setState({ docProcessing: false, showPop: false, saveFormat: "Word" })
            });
        }
    }
    const handleOnChangeExportOriginalText = (event) => {
        setIsExportOriginalText(!isExportOriginalText)
    }

    return (<>
        <Modal
            show={props.showPop}
            size="md"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="popup-transition"
            className="z-index-create-notebook"
            backdropClassName="z-index-create-notebook-backdrop"
            scrollable={true}
        >
            <div style={{ overflow: "auto", borderRadius: '16px' }}>

                <div className="popup-cancel-btn-wrapper" onClick={() => props.handleClose()}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                </div>
                <div>
                    <Modal.Header className="gsfModalHeader modal-header" style={{ justifyContent: "left", background: 'none', gap: '8px', marginBottom: '10px' }}>
                        <div style={{ textAlign: "left", width: "100%", paddingTop: "1%" }}>
                            <Modal.Title style={{ fontSize: '20px' }}>
                                Create Draft for Notebook
                            </Modal.Title>
                        </div>
                    </Modal.Header>
                    <Modal.Body scrollable={true}>
                        <div>
                            <div>
                                <div>
                                    <span className="gsf-popup-inputHeading">Format :</span><br />
                                    <div className="nbv-popup-inputContainer">
                                        <div className="gsf-popup-inputPart">
                                            <input type="radio" className="gsf-popup-radioInput k-radio-note" name="formathtml" value="Word" onChange={handleOnChangeSaveFormat} checked={saveFormat === 'Word'} />
                                            <label style={{ color: saveFormat === 'Word' ? "#333" : "#63666A" }}>Word</label>
                                        </div>
                                        {/* <div className="gsf-popup-inputPart">
                                            <input type="radio" className="gsf-popup-radioInput k-radio" name="formatExcel" value="Excel" onChange={handleOnChangeSaveFormat} checked={saveFormat === 'Excel'} />
                                            <label style={{ color: saveFormat === 'Excel' ? "#333" : "#63666A" }}>Excel</label>
                                        </div> */}

                                        <div className="gsf-popup-inputPart">
                                            <input type="radio" className="gsf-popup-radioInput k-radio-note" name="formatpdf" value="Pdf" onChange={handleOnChangeSaveFormat} checked={saveFormat === 'Pdf'} />
                                            <label style={{ color: saveFormat === 'Pdf' ? "#333" : "#63666A" }}>Pdf</label>
                                        </div>
                                    </div>
                                    {/* <div className="nbv-popup-inputContainer-checkbox">
                                        <div className="gsf-popup-inputPart-checkbox">
                                            <input type="checkbox" name="ExportOriginalText" value="Export Original Text" onChange={handleOnChangeExportOriginalText} checked={isExportOriginalText} />
                                            &nbsp;
                                            <label style={{ color: isExportOriginalText ? "#333" : "#63666A", cursor: "pointer" }} onClick={handleOnChangeExportOriginalText}> Export Original Text</label>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    {
                        <div className="nbv-popup-button-wrapper">
                            <Button text="Cancel" customColor="#756e6e" action={() => { setShowPop(false); props.handleClose() }} />
                            <Button text="Proceed" customColor="#EB1007" action={onClickProceed} />
                        </div>
                    }
                </div>
            </div>
            {docProcessing &&
                <Modal
                    show={docProcessing}
                    size="lg md sm xs"
                    centered
                    aria-labelledby="contained-modal-title-vcenter"
                    dialogClassName="savePopUp"
                    className={"document-processing-contentPopUp"}
                    scrollable={true}
                    backdropClassName={'document-processing-contentPopUp-backdrop'}>
                    <div style={{ padding: "0 5%" }}>
                        <div style={{ fontSize: "14px", textAlign: "center" }}>
                            <Modal.Body>
                                <img src={imsLoader} alt="" width={100} height={100} />
                                <div className="saveModal-heading" style={{ color: "#EB1700" }}>{`Please wait while saving the document.`} </div>
                            </Modal.Body>
                        </div>
                    </div>
                </Modal>}
        </Modal>
    </>)
}
export default NoteBookExport;